// extracted by mini-css-extract-plugin
export default {"sectionw":"donations_sectionw__Gz-jb","card":"donations_card__tnPDt","pinCode":"donations_pinCode__79rMD"};